export const LOGO_WHITE = require('./wgl-logo-white.png');
export const LOGO = require('./wgl-logo.png');
export const IMAGE_PLACEHOLDER = require('./image-placeholder.png');
